import { useQuery } from '@tanstack/react-query';
import useProductId from '@/app/[locale]/new/(products)/[productType]/[...slug]/components/hooks/useProductId';
export default function useGetDiveShopInfo() {
    const productId = useProductId();
    return useQuery({
        queryKey: [`/api/adventure/v2/activities/${productId}/dive-center/`],
        enabled: Boolean(productId),
    });
}
